<template>
  <div>
    <!-- 搜索区 -->
    <search-component @handleQueryData="handelSearch" @handleFilterData="handleFilter" />
    <!--客户搜索筛选框-->
    <apply-search :show.sync="showFilterPop" @handlequery="handleFqueryFilter" />
    <van-list v-model="loading" :finished="finished"  finished-text="没有更多了" @load="onLoad" v-if="list.length > 0">
      <total-component :totalValue="total" />
      <van-cell v-for="(item, index) in list" :key="index" @click="toDetails(item)" >
        <div style="display: flex; align-items: center; height:100%; width:100%">
          <div style="flex: 1;">
            <div class="custName-wrap" style="padding: 0;">
              <div class="custName">
                {{item.serviceTypeName}}
              </div>
            </div>
            <div style="color: #999; font-size: 12px">部门名称：{{item.deptName}}   领取总数：{{item.templateTotal}}</div>
            <div style="color: #ccc; font-size: 12px">已使用数量： {{item.useTotal}}  归还数量：{{ item.returnTotal}}</div>
          </div>
          <van-icon style="flex:0.1;" color="#c1c1c1" name="arrow" size="16" class="arrow-color" />
        </div>
      </van-cell>
    </van-list>
    <empty-component v-if="isEmpty" />
  </div>
</template>

<script>
import moment from "moment"
import {listApplyDecord} from "@/api/cont/contract"
import { getDicts } from "@/api/system/dict/data";
import SearchComponent from "@/components/common/Search";
import ApplySearch from '../components/contract/ApplySearch.vue'
import EmptyComponent from "@/components/common/Empty";
import TotalComponent from "@/components/common/Total";
import { Tab, Tabs  } from 'vant'
export default {
  name: "applyDecord",
  components: {
    SearchComponent,ApplySearch,EmptyComponent,TotalComponent,
    [Tab.name]: Tab,
    [Tabs.name]: Tabs,
  },
  filters: {
    timeFormat(val) {
      return moment(val).format("YYYY-MM-DD");
    }
  },
  data() {
    return {
      deptTreeList:[],
      add_show: false,
      isEmpty: false,
      loading: false,
      finished: false,
      list: [],
      total: 0,
      showFilterPop: false,
      custList: [],
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        orderByColumn: 'createTime',
        isAsc: 'desc'
      }
    };
  },
  created(){
    this.handleList()
  },
  mounted() {
    this.init();
  },
  methods: {
    async init() {
       document.title = "申领合同"
    },
    // 搜索子组件传递过来的搜索关键字
    handelSearch(data) {
      this.queryParams.serviceTypeName = data;
      this.queryCustList()
    },
    // 过滤子组件传递过来的搜索对象
    handleFqueryFilter(data) {
      let query = this.queryParams;
      this.queryParams = { ...query, ...data }
      this.queryCustList()
      this.showFilterPop = false
    },
    queryCustList() {
      this.list = [];
      this.queryParams.pageNum = 1;
      this.queryParams.pageSize = 10;
      this.handleList();
    },
    // 接收子组件的filter事件
    handleFilter() {
      this.showFilterPop = true
    },
    toDetails(item) {
      this.$router.push({
        path: '/cont/apply/decordDetail',
        query: {deptId: item.deptId, serviceTypeId: item.serviceTypeId}
      })
    },
    async handleList() {
      this.loading = true; 
       const res = await listApplyDecord(this.queryParams);
 
      if (res.code === 200) {
        console.log(res)
        if (res.rows.length === 0) {
          this.isEmpty = true
        }
        this.list = this.list.concat(...res.rows); 
        this.queryParams.pageNum += 1;
        this.total = res.total;
        this.finished = this.list.length >= res.total;
        this.loading = false
      }
    },
    onLoad() {
      this.handleList();
    },
    //添加合同
    async addContractBeforeClose() {
      this.add_show = false
      await this.queryCustList()
    },
  },
};
</script>
<style lang="less" scoped>
@import url("@/style/index.less");
.van-tabs {
  position: relative;
  top: 1.25rem;
}
.tips{
  min-width: 3.1rem;
  font-size: .2rem;
  color: rgb(247, 155, 35);
}
/deep/ .van-tabs__line {
    position: absolute;
    bottom: 0.4rem;
    left: 0;
    z-index: 1;
    width: 1.06667rem;
    height: 0.08rem;
    background-color: #0a315d;
    border-radius: 0.08rem;
}
.editVisit{
    min-height: 9rem;
    height: 50%;
    top: 46%;
    .formSty{
      height: 100%; overflow: scroll; margin: 10px 5px;
    }
}
.editVisit /deep/.van-dialog__content {
  height: 83%;
  .van-field--error .van-field__control{
    font-size: 0.38rem;
  }
  .van-field__control{font-size: 0.38rem;}
}
.editVisit /deep/.van-dialog__content {
  height: 70%;
}
</style>